
<div class="global-container">

    <button 
        mat-raised-button 
        color="primary"
        class="base_buttons"
        type="button" 
        style="width: 100%;"
        (click)="loginButtonclicked('google')">
            {{languageService.Strings.buttons.button_loginGoogle}}
    </button>
    
    <button 
        mat-raised-button 
        color="primary"
        class="base_buttons"
        type="button" 
        style="width: 100%;"
        (click)="loginButtonclicked('microsoft')">
            {{languageService.Strings.buttons.button_loginMicrosoft}}
    </button>

</div>
